import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class CreateConcessionCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) {}

  run(concession_number, reason, staff_username): Promise<{ [key: string]: object; }> {
    let args = {
      concession_number:concession_number,
      reason:reason,
      staff_username:staff_username
    };
    try {
      return this.dispatcher.dispatch('create.concession', args);
    } catch(error) {
      console.error('Error al crear la Conecesión', error)
    }
  }
}